import React, { useState, useEffect } from "react";
import axios from "axios";

import ForecastDay from "./ForecastDay";

export default function Forecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecastInfo, setForecastInfo] = useState(null);
  function displayForecast(response) {
    setLoaded(true);
    setForecastInfo(response.data.daily);
  }
  useEffect(() => {
    setLoaded(false);
  }, [props.info.placename]);

  if (loaded) {
    return (
      <div className="forecast">
        <div className="row">
          {forecastInfo.map(function (forecast, index) {
            if (index < 5) {
              return (
                <div className="col p-0" key={index}>
                  <ForecastDay info={forecast} />
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    const apiKey = "fab80702t0ae63d380b14ab9a413do4f";
    const units = "metric";

    const apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${props.info.placename}&key=${apiKey}&units${units}`;
    axios.get(apiUrl).then(displayForecast);
    return null;
  }
}
